// Shared bits for the customer popup tabs: the FieldRoutes id (resolved server-side
// through the mirror link) and the one card look every tab uses (CustomerOverview.css).
import React from "react";
import "./customerTabs.css";

export function frIdOf(record) {
  const raw = record?.raw || {};
  return String(raw.fieldroutes?.customer_id || raw.fieldroutes_customer_id || "").trim() || null;
}

export function TabState({ children }) {
  return <div className="ct-state">{children}</div>;
}

export function TabNote({ children }) {
  return <div className="ct-note-bar">{children}</div>;
}
